/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreBookingResponse
 */
export interface PreBookingResponse {
    /**
     * 
     * @type {string}
     * @memberof PreBookingResponse
     */
    preBookingUuid: string;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingResponse
     */
    shouldRegister: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreBookingResponse
     */
    additionalDriverCode?: string;
}

/**
 * Check if a given object implements the PreBookingResponse interface.
 */
export function instanceOfPreBookingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "preBookingUuid" in value;
    isInstance = isInstance && "shouldRegister" in value;

    return isInstance;
}

export function PreBookingResponseFromJSON(json: any): PreBookingResponse {
    return PreBookingResponseFromJSONTyped(json, false);
}

export function PreBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preBookingUuid': json['preBookingUuid'],
        'shouldRegister': json['shouldRegister'],
        'additionalDriverCode': !exists(json, 'additionalDriverCode') ? undefined : json['additionalDriverCode'],
    };
}

export function PreBookingResponseToJSON(value?: PreBookingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preBookingUuid': value.preBookingUuid,
        'shouldRegister': value.shouldRegister,
        'additionalDriverCode': value.additionalDriverCode,
    };
}

